import { useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { LogErrors } from './../../../../../utilities/LogErrors'

//import { InstructorBase } from './../../../../Layouts/Instructor/InstructorBase'
import { InstructorBase } from './../../../../Layouts/Instructor/V2/InstructorBase'
import { Loading } from './../../../../Common/Loading'

import { SaveCourseToShow } from './../../../../../utilities/BL/Navigation'
import { ValidateSession } from './../../../../../utilities/BL/Sessions'
//import { GetCourses as BLGetCourses } from './../../../../../utilities/BL/Instructor/Syllabus'
import { GetCourses as BLGetCourses } from './../../../../../utilities/BL/Instructor/Agendas'
import { Search } from './../../../../Common/Tables/Search'
import { HELP_TYPE } from './../../../../../utilities/EL/HelpType'
import { WEBPAGES } from './../../../../../utilities/EL/WebPages'
import { ROLES } from './../../../../../utilities/EL/Roles'

//import { HELP_TYPE } from './../../../../Header/Header'
//import { useTawkChat } from './../../../../../Support/Chat/Chat'



const Syllabus = () => {
    const navigate = useNavigate()

    const [isLoading, setIsLoading] = useState(true)
    const [session, setSession] = useState({})
    
    const rolesData = {
        ZTUDIANTE: 1,
        INSTRUCTOR: 2
    }

    //--- Commons to Table and Search ---//
        
    const [courses, setCourses] = useState([])
    const [searchText, setSearchText] = useState('')

    const coursesRef = useRef([])

    useEffect(() => {
        coursesRef.current = courses
    }, [courses])
    
    // const filteredCourses = useMemo(() => {
    //     if (!searchText) return courses
    //     return courses.filter((row) =>
    //         row.name.toLowerCase().includes(searchText.toLowerCase())
    //     )
    // }, [searchText, courses])

    // const filteredCourses = useMemo(() => {
    //     const search = (searchText ?? '').trim().toLowerCase()
    //     if (!search) return courses

    //     return (courses ?? []).filter((course) => {
    //         const courseName = (course?.nameCourse ?? '').toLowerCase()
    //         const levelText = course?.level != null ? String(course.level).toLowerCase() : ''
    //         const fullText = `${courseName} ${levelText}`.trim()

    //         return fullText.includes(search)
    //     })
    // }, [searchText, courses])

    const filteredCourses = useMemo(() => {
        const search = (searchText ?? '').trim().toLowerCase()
        if (!search) return courses

        return (courses ?? []).filter((course) => {
            const name = (course?.nameCourse ?? '').toLowerCase()

            // level puede venir como string "1" o null/undefined
            const levelValue = course?.level != null ? String(course.level).trim() : ''

            // armamos variantes que el usuario podría escribir
            const levelLabel = levelValue ? `nivel ${levelValue}` : ''

            // Texto final contra el que hacemos la búsqueda
            const searchableText = `${name} ${levelLabel} ${levelValue}`.trim()

            return searchableText.includes(search)
        })
    }, [searchText, courses])


    const handleSearch = (value) => {
        setSearchText(value)
    }

    //--- Commons to Table and Search ---//


    const GoToNextView = async (course) => {
        try {
            setIsLoading(true)
            
            const response = await SaveCourseToShow(session, course, false, rolesData.INSTRUCTOR)
            
            if (response.success) {                
                setSession(response.data)
                navigate('/course')
            }
        } catch (error) {
            await LogErrors('GoToNextView - Syllabus', error)
            return { success: false, message: '' }
        } finally {
            setIsLoading(false)
        }
    }

    const LoadPage = async (sessionInfo) => {
        try {
            const response = await BLGetCourses()
            
            if (response.success) {
                setCourses(response.data)
            }

            setSession(sessionInfo)
        } catch (error) {
            await LogErrors('LoadPage - Syllabus', error)
        } finally {
            setIsLoading(false)
        }
    }

    /**
     * Función para obtener la configuración, una vez que termine de cargarse el componente
     */
    useEffect(() => {
        async function Validate() {
            const tmpSession = await ValidateSession()
            
            if (tmpSession.success) {
                if (tmpSession.data.user.userStatus === 2) {
                    await LoadPage(tmpSession.data)
                } else {
                    navigate('/confirm')
                }
            } else {
                navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
            }
        }
        Validate()
    }, []) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar


    //useTawkChat(true) // Activamos el chat en esta página

    //console.log('first course example:', courses?.[0])


    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <InstructorBase urlToGo={'/dashboard'} page={WEBPAGES.INSTRUCTOR.SYLLABUS} role={ROLES.INSTRUCTOR}>
                    <section className='container Instructor__Syllabus'>
                        <p className='Instructor__Title Instructor__Title--Center Instructor__SpaceUp'>Temarios</p>
                        {courses && (
                            <p className='Instructor__Subtitle Instructor__Title--Center'>Total de temarios: {courses.length && courses.length}</p>
                        )}

                        <Search onChange={handleSearch} extraClassName={'Instructor__Syllabus__Search'} />

                        <div>
                            {courses ? (
                                courses.length === 0 ? (
                                    <p className='Instructor__Text--Center Instructor__SpaceUp'>Actualmente no hay temarios por mostrar.</p>
                                ) : (
                                    filteredCourses.length === 0 ? (
                                        <p className='Instructor__Text--Center Instructor__SpaceUp'>No se encontró algún temario con la búsqueda realizada. Intenta con otra.</p>
                                    ) : (
                                        filteredCourses.map((course, index) => (
                                            <div key={index} className='Instructor__Syllabus__CoursesList'>
                                                <button type='button' className='Instructor__Syllabus__CoursesList__Items Tables--Shadow' onClick={() => GoToNextView(course)}>
                                                    <span className='Instructor__Syllabus__CoursesList__Items__Text'>
                                                        {course.nameCourse}{course.level ? ` nivel ${course.level}` : ''}
                                                    </span>
                                                    {/* <span className='Instructor__Syllabus__CoursesList__Items__Text Instructor__Syllabus__CoursesList__Items__Text--Small'>
                                                        {course.type === 1 ? 'Certificación' : 'Acreditación'}
                                                    </span> */}
                                                </button>
                                            </div>
                                        ))
                                    )
                                )
                            ) : (
                                <p className='Instructor__Text--Center Instructor__SpaceUp'>No ha sido posible mostrar el listado de temarios. Intenta actualizar la página o inténtalo más tarde.</p>
                            )}
                        </div>
                    </section>
                </InstructorBase>
            )}
        </>
    )
}

export { Syllabus };